import { render, staticRenderFns } from "./Pricing.vue?vue&type=template&id=14911267"
var script = {}


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports

/* nuxt-component-imports */
installComponents(component, {SectionHeader: require('/opt/build/repo/components/section/Header.vue').default,ShopPricingTable: require('/opt/build/repo/components/shop/PricingTable.vue').default})
